export default function getAcknowledgeAllEventsURL(): string {
  return `/notifications/events/applications/opus/channels/on_site/acknowledgeAll`;
}
